<template>
  <div v-bind:class="{ 'popup-backdrop': true, 'popup-backdrop-disabled': isDisabled }">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'PopupBackdrop',
    props: {
      isDisabled: Boolean
    }
  }
</script>

<style scoped>
  .popup-backdrop {
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.75);
  }
  .popup-backdrop-disabled {
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0.24) 143.61%
    );
  }

  @media (max-width: 600px) {
    .popup-backdrop {
      top: 56px;
      backdrop-filter: blur(15px);
    }
  }
</style>
